import {
  AnalyticsProductDto,
  ExperienceProductDto,
} from "@intelligems/ig-types";

import { fromGqlId } from "./shopify";

export function testProductsFromGqlId<
  T extends ExperienceProductDto | AnalyticsProductDto,
>(testProducts: T[]) {
  return testProducts.map((product) => {
    return { ...product, id: fromGqlId(product.id) };
  });
}
